<!-- ChatbotPanelComponent — Panel deslizable principal del chatbot -->
<!-- Req 5.3, 5.4, 5.5, 5.6, 5.7, 5.8, 4.2, 4.3 -->

<div class="chatbot-panel">

  <!-- =========================================================
       BARRA SUPERIOR: título + estado de conexión
       ========================================================= -->
  <div class="chatbot-panel__header">

    <!-- Botón historial — solo visible en tablet/móvil -->
    <button
      class="chatbot-panel__history-btn"
      (click)="toggleDrawer()"
      [attr.aria-expanded]="isDrawerOpen"
      aria-label="Ver conversaciones anteriores"
      title="Conversaciones anteriores"
      type="button"
    >
      <i class="bi bi-layout-sidebar" aria-hidden="true"></i>
    </button>

    <div class="chatbot-panel__title">
      <i class="bi bi-robot me-2" aria-hidden="true"></i>
      <span>Asistente Cooper T. Smith</span>
    </div>

    <!-- Indicador de estado de conexión — Req 5.6 -->
    <span
      class="chatbot-panel__status-badge"
      [ngClass]="connectionStatusClass"
      [attr.title]="connectionStatusLabel"
      role="status"
      [attr.aria-label]="'Estado de conexión: ' + connectionStatusLabel"
    >
      <span class="chatbot-panel__status-dot" aria-hidden="true"></span>
      {{ connectionStatusLabel }}
    </span>
  </div>

  <!-- =========================================================
       CUERPO: sidebar de sesiones + área principal
       ========================================================= -->
  <div class="chatbot-panel__body">

    <!-- ---------------------------------------------------------
         SIDEBAR: lista de sesiones — Req 4.2
         --------------------------------------------------------- -->
    <aside class="chatbot-panel__sidebar" aria-label="Conversaciones anteriores">
      <app-session-list
        (sessionSelected)="selectSession($event)"
        (newSessionRequested)="createNewSession()"
      ></app-session-list>
    </aside>

    <!-- ---------------------------------------------------------
         DRAWER: historial en tablet/móvil
         --------------------------------------------------------- -->
    <div
      class="chatbot-panel__drawer-overlay"
      [class.chatbot-panel__drawer-overlay--visible]="isDrawerOpen"
      (click)="closeDrawer()"
      aria-hidden="true"
    ></div>

    <aside
      class="chatbot-panel__drawer"
      [class.chatbot-panel__drawer--open]="isDrawerOpen"
      aria-label="Conversaciones anteriores"
    >
      <div class="chatbot-panel__drawer-header">
        <span class="chatbot-panel__drawer-title">Conversaciones</span>
        <button
          class="chatbot-panel__drawer-close"
          (click)="closeDrawer()"
          aria-label="Cerrar historial"
          type="button"
        >
          <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
      </div>
      <app-session-list
        (sessionSelected)="onDrawerSessionSelected($event)"
        (newSessionRequested)="onDrawerNewSession()"
      ></app-session-list>
    </aside>

    <!-- ---------------------------------------------------------
         ÁREA PRINCIPAL: mensajes + input
         --------------------------------------------------------- -->
    <section class="chatbot-panel__main" aria-label="Área de conversación">

      <!-- Estado vacío: sin sesión activa ni mensajes -->
      <div
        *ngIf="!activeSession && messages.length === 0"
        class="chatbot-panel__empty-state"
        aria-live="polite"
      >
        <i class="bi bi-chat-dots chatbot-panel__empty-icon" aria-hidden="true"></i>
        <p class="fw-semibold mb-1">¿En qué puedo ayudarte?</p>
        <p class="text-muted small mb-0">
          Escribe tu pregunta sobre reglas de negocio, flujos operativos o el uso del sistema.
        </p>
      </div>

      <!-- Loader: cargando historial de una sesión -->
      <div
        *ngIf="isLoadingHistory"
        class="chatbot-panel__history-loader"
        aria-live="polite"
        role="status"
      >
        <div class="chatbot-panel__spinner" aria-hidden="true"></div>
        <span>Cargando conversación…</span>
      </div>

      <!-- Área de mensajes — Req 5.4, 5.5 -->
      <div
        #messagesContainer
        class="chatbot-panel__messages"
        *ngIf="(activeSession || messages.length > 0) && !isLoadingHistory"
        aria-live="polite"
        aria-label="Mensajes de la conversación"
        role="log"
      >
        <app-chatbot-message
          *ngFor="let msg of messages; let i = index; trackBy: trackByIndex"
          [message]="msg"
          [isStreaming]="isLoading && i === messages.length - 1 && msg.role === 'assistant'"
        ></app-chatbot-message>
      </div>

      <!-- ---------------------------------------------------------
           ÁREA DE INPUT — Req 5.9
           --------------------------------------------------------- -->
      <div class="chatbot-panel__input-area">
        <div class="chatbot-panel__input-wrapper">
          <textarea
            #messageInput
            class="form-control chatbot-panel__textarea"
            [(ngModel)]="inputText"
            (keydown)="onKeyDown($event)"
            placeholder="Escribe tu pregunta…"
            rows="1"
            maxlength="2000"
            [disabled]="isLoading"
            aria-label="Campo de mensaje"
            aria-describedby="input-hint"
          ></textarea>

          <button
            class="btn chatbot-panel__send-btn"
            (click)="sendMessage()"
            [disabled]="isSendDisabled"
            title="Enviar mensaje (Enter)"
            aria-label="Enviar mensaje"
            type="button"
          >
            <i class="bi bi-send-fill" aria-hidden="true"></i>
          </button>
        </div>

        <p class="chatbot-panel__input-hint" id="input-hint">
          Presiona <kbd>Enter</kbd> para enviar &middot; <kbd>Shift+Enter</kbd> para nueva línea
        </p>
      </div>

    </section>
  </div>

</div>
